import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import Select from "react-select";
import globalstyle from "src/assets/scss/global.module.scss";
import { BackButton, Loader } from "src/components";
import { Title } from "src/constants/constVariables";
import { CustomTab } from "src/components";
import MonthYearFilter from "../../components/Atoms/MonthYearFilter/MonthYearFilter";
import styles from "./MisReports.module.scss";
import MisTableComponent from "../../components/MisTableComponent/MisTableComponent";
import { baseApiCall } from "src/api/Api";
import { mis_reports_all_endpoints, user_management_service } from "src/constants/url";
import { commonVaribles } from "src/constants/constVariables";
import { store } from 'src/redux';
import { useSelector } from "react-redux";
import moment from "moment/moment";
import { Button } from "src/components";
import {customStyle} from './constants';
import { constants } from "src/constants/constant";
import {
  headerInfoPlantWise,
  headerInfoUserWise,
  UserWiseTableHeader,
  downloadMisReportSummury
} from "./constants";
import YearlyTable from "../../components/YearlyTable/YearlyTable.js";
import PlantVsCostTable from "../../components/PlantVsCostTable/plantVsCostTable.js";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import MisReportGraph from "../../components/MisReportGraph/MisReportGraph.js";
import { useDispatch } from "react-redux";
import { onResponse } from "src/redux/features";
import { formatDate, replacingCommaToX } from "src/constants/utils";
import clsx from "clsx";

const MisContainerPageCard = ({ header, value }) => (
  <div className={styles.misContainerPageCard}>
    <span>{header}</span>
    <div className={styles.misContainerPageCardData}>
      {header.includes("(Cr.)") ? (
        <>
          <span>₹ {value} Cr</span>
        </>
      ) : (
        <span>{value} </span>
      )}
    </div>
  </div>
);

export default function MisReports() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [currentTab, setCurrentTab] = useState("Monthly");
  const [cardData, setCardData] = useState([]);
  const currentDate = new Date(); // Get current date
  const currentYear = currentDate.getUTCFullYear();
  const currentMonth = currentDate.getUTCMonth();

  const [monthlyDates, setMonthlyDates] = useState({
    start_date: moment
      .utc(new Date(currentYear, currentMonth, 2))
      .format("YYYY-MM-DD"),
    end_date: moment
      .utc(new Date(currentYear, currentMonth + 1, 1))
      .format("YYYY-MM-DD"),
  });
  const [userWiesData, setUserWiesData] = useState([]);
  const [plantWise, setplantWise] = useState([]);
  const tabs = ["Monthly", "Yearly", "Plantwise"];
  const plantDataList = useSelector((state) => state.allPlants.plants);
  
  const allPlantValues = plantDataList ? plantDataList.map((plant) => plant.value) : [];

  const [selectedPlantName, setSelectedPlantName] = useState(
    { label: 'All', value: allPlantValues }
  );

  const modifiedPlantDataList = [
		{ label: 'All', value: allPlantValues }, // First option with an array of plant values
		...plantDataList.map((plant) => {
			if (plant && typeof plant == 'object') {
				return {
					label: plant?.label,
					value: plant?.value // User access plant value
				};
			}
			return plant;
		}),
	];

  const [selectedMonthYear, setSelectedMonthYear] = useState(
    JSON.stringify({ month: currentMonth, year: currentYear })
  );
  const [selectedYear, setSelectedYear] = useState(
    JSON.stringify({ year: currentYear })
  );
  const [otherData, setOtherData] = useState([]);

  const [activeUsers, setActiveUsers] = useState([]);
  const [currentUser, setCurrentUser] = useState([]);
  const [partCost, setPartCost] = useState([]);
  const [yearlyPlantWiseTable, setYearlyPlantWiseTable] = useState([]);
  const [supplierWiseProgressTable, setSupplierWiseProgressTable] = useState([]);
  const [modelWiseConstingTable, setModelWiseConsting] = useState([]);
  const [incotermData, setIncotermData] = useState([]);
  const [userWiseInfo, setUserWiseInfo] = useState([]);

  const [plantWiseSheet, setPlantWiseSheet] = useState({});
  const [percentageData, setPercentageData] = useState({});
  const [returnableExpendableCostData, setReturnableExpendableCostData] = useState({});
  const [IncoTermWiseCostData, setIncoTermWiseCostData] = useState({});
  const [logisticsCostData, setLogisticsCostData] = useState({});
  const [annualCostData, setAnnualCostData] = useState({});
  const [annualRecommendationsData, setAnnualRecommendationsData] = useState(
    {}
  );
  const [countAndCostData, setCountAndCostData] = useState({});
  const [isAllUser, setIsAllUser] = useState(true);

  const [selectedOption, setSelectedOption] = useState({
    selected_plant: null, // You can also start with a default value if needed
  });

  const [activeUserRoles, setActiveRoles] = useState([]);
  const [currentRole, setCurrentRole] = useState([]);
  const [isAllURoles, setIsAllRoles] = useState(true);
  const [userRoleWiseInfo, setUserRoleWiseInfo] = useState([]);

  const tabContent = {
    Monthly: {
      cards: cardData,
      table1: {
        headerName: "Monthly Plant-wise Data",
        headerInfo: headerInfoPlantWise,
        rowData: plantWise,
        isheaderColor: false,
        iscount: true,
        isYearly: false,
      },
      table2: {
        headerName: "Monthly User-wise Data ",
        headerInfo: headerInfoUserWise,
        rowData: userWiesData,
        isheaderColor: true,
        iscount: true,
        isYearly: false,
      },
      table3: {
        headerName: "Monthly User-Role-wise Progress Data ",
        rowData: userRoleWiseInfo,
        data: true,
        isUserDropDown: true,
      },
      table4: {
        headerName: "Monthly Model-wise Costing Data (Cr.)",
        data: true,
      },
      misCardSection: true,
    },
    Yearly: {
      plantVsCostTable: {
        headerName: "Recommended Logistics Sheet",
        data: partCost,
      },
      yearlysTable1: {
        headerName: "Plant Wise Logistics cost & Packaging Strategy ",
        data: true,
      },
      yearlysTable2: {
        headerName: "Inco Terms, Tonnage & Related Strategy",
        data: true,
      },
      table1: {
        headerName: "Monthly User-wise Data",
        headerInfo: UserWiseTableHeader,
        rowData: userWiseInfo,
        isheaderColor: false,
        iscount: true,
        isUserDropDown: true,
        isYearly: true,
      },
    },
    Plantwise: {
      graph: true,
    },
  };

	//Call UserRoleWise after activeUserRoles has been updated
	useEffect(() => {
		if (activeUserRoles?.length > 0) {
			UserRoleWise(); // Call this only after activeUserRoles is populated
		}
	}, [activeUserRoles, currentRole]);

  useEffect(() => {
    ActiveUserList();
    switch (currentTab) {
      case "Monthly":
        fetchCardDataMonthly();
        plantTablesDataMonthly();
        userTablesDataMonthly();
        //getSupplierWiseProgressData();
        fetchUserRoleList();
        //otherDataMonthly();
        modelsWiseCostingDataMonthly();
        break;
      case "Yearly":
        yearlyPlantWiseDataYearly();
        Plantwise_Exp_Vs_strategy();
        Incoterm_data();
        UserWise();
        break;
      case "Plantwise":
        getPlantWiseogisticsSheetData();
        getPlantWiseLogisticsReturnablePercentageData();
        getPlantWiseLogisticsReturnableExpendableCostData();
        getPlantWiseLogisticsCostData();
        getPlantWiseogisticsAnnualCostData();
        getPlantWiseogisticsAnnualRecommendationsData();
        getPlantWiseIcoTermWiseCostData();
        // getPlantWiseogisticsAnnualRecommendationsCountAndCostData();
        break;
      default:
        break;
    }
    setLoader(true);
  }, [currentTab, selectedMonthYear, monthlyDates, selectedPlantName, selectedOption]);

  useEffect(() => {
    UserWise();
  }, [currentUser]);
  
  const handleTabClick = (tabName) => {
		// reset Plant
		setSelectedPlantName({ label: 'All', value: allPlantValues });
		setCurrentTab(tabName);
		const currentDate = new Date();
		const currentYear = currentDate.getUTCFullYear();
		const currentMonth = currentDate.getUTCMonth();

		if (tabName === 'Monthly') {
			setSelectedMonthYear(
				JSON.stringify({ month: currentMonth, year: currentYear })
			);
			setMonthlyDates({
				start_date: moment
					.utc(new Date(currentYear, currentMonth, 2))
					.format('YYYY-MM-DD'),
				end_date: moment
					.utc(new Date(currentYear, currentMonth + 1, 1))
					.format('YYYY-MM-DD'),
			});
		} else {
			setMonthlyDates({
				start_date: moment
					.utc(new Date(currentYear, 3, 2))
					.format('YYYY-MM-DD'),
				end_date: moment
					.utc(new Date(currentYear + 1, 3, 1))
					.format('YYYY-MM-DD'),
			});
		}
	};

  //monthly
  const fetchCardDataMonthly = () => {
    setLoader(false);
    setCardData([]);
    baseApiCall({
      url: mis_reports_all_endpoints.GET_MONTHLY_KPI_DATA,
      requestBody: {
        start_date: monthlyDates?.start_date,
        end_date: monthlyDates?.end_date,
        plant_ids: selectedPlantName?.label === "All" ? selectedPlantName?.value : [selectedPlantName?.value],
      },
      method: commonVaribles.post,
      onSuccess: (res) => {
        if (res && res.data && res.data.result && res.data.result !== "") {
          const data = res.data.result;
          setCardData(data);
          setLoader(true);
        } else {
          setLoader(true);
        }
      },
      onFailure: () => {
        setLoader(false);
      },
      errorCall: () => {
        setLoader(false);
      },
    });
  };

  const plantTablesDataMonthly = () => {
    setLoader(false);
    setplantWise([]);
    baseApiCall({
      url: mis_reports_all_endpoints.GET_MONTHLY_PLANT_WISE_DATA,
      requestBody: {
        start_date: monthlyDates?.start_date,
        end_date: monthlyDates?.end_date,
        plant_ids: selectedPlantName?.label === "All" ? selectedPlantName?.value : [selectedPlantName?.value],
      },
      method: commonVaribles.post,
      onSuccess: (res) => {
        if (res && res.data && res.data.result && res.data.result !== "") {
          const data = res.data.result;
          setplantWise(data);
          setLoader(true);
        } else {
          setplantWise(res.data.message);
          setLoader(true);
          dispatch(
            onResponse({
              isToaster: true,
              severity: commonVaribles.success,
              message: res.data.message,
            })
          );
        }
      },
      onFailure: () => {
        setLoader(false);
      },
      errorCall: () => {
        setLoader(false);
      },
    });
  };

  const userTablesDataMonthly = () => {
    setLoader(false);
    setUserWiesData([]);
    baseApiCall({
      url: mis_reports_all_endpoints.GET_MONTHLY_USER_WISE_DATA,
      requestBody: {
        start_date: monthlyDates?.start_date,
        end_date: monthlyDates?.end_date,
        plant_ids: selectedPlantName?.label === "All" ? selectedPlantName?.value : [selectedPlantName?.value],
      },
      method: commonVaribles.post,
      onSuccess: (res) => {
        if (res && res.data && res.data.result && res.data.result !== "") {
          const data = res.data.result;
          setUserWiesData(data);
          setLoader(true);
        } else {
          setUserWiesData(res.data.message);
          setLoader(true);
          dispatch(
            onResponse({
              isToaster: true,
              severity: commonVaribles.warning,
              message: res.data.message
            })
          );
        }
      },
      onFailure: () => {
        setLoader(false);
      },
      errorCall: () => {
        setLoader(false);
      },
    });
  };

  const otherDataMonthly = () => {
    setLoader(false);
    setOtherData([]);
    baseApiCall({
      url: mis_reports_all_endpoints.GET_MONHTLY_OTHER_DATA,
      requestBody: {
        start_date: monthlyDates?.start_date,
        end_date: monthlyDates?.end_date,
        plant_ids: selectedPlantName?.label === "All" ? selectedPlantName?.value : [selectedPlantName?.value],
      },
      method: commonVaribles.post,
      onSuccess: (res) => {
        if (res && res.data && res.data.result && res.data.result !== "") {
          const data = res.data.result;
          setOtherData(data);
          setLoader(true);
        } else {
          setOtherData(res.data.message);
          dispatch(
            onResponse({
              isToaster: true,
              severity: commonVaribles.success,
              message: res.data.message,
            })
          );
          setLoader(true);
        }
      },
      onFailure: () => {
        setLoader(false);
      },
      errorCall: () => {
        setLoader(false);
      },
    });
  };

  const modelsWiseCostingDataMonthly = () => {
    setLoader(false);
		setModelWiseConsting([]);
		baseApiCall({
			url: mis_reports_all_endpoints.GET_MODEL_WISE_COSTING_DATA,
			requestBody: {
				start_date: monthlyDates?.start_date,
				end_date: monthlyDates?.end_date,
				plant_ids: selectedPlantName?.label === "All" ? selectedPlantName?.value : [selectedPlantName?.value],
			},
			method: commonVaribles.post,
			onSuccess: (res) => {
				if (res?.data?.result?.length && res?.data?.result !== '') {
					const data = res.data.result;
					setModelWiseConsting(data);
					setLoader(true);
				} else {
					setModelWiseConsting(res.data.message);
					dispatch(
						onResponse({
							isToaster: true,
							severity: commonVaribles.success,
							message: res.data.message,
						})
					);
					setLoader(true);
				}
			},
			onFailure: () => {
				setLoader(false);
			},
			errorCall: () => {
				setLoader(false);
			},
		});
	};

  //yearly

  const yearlyPlantWiseDataYearly = () => {
    setLoader(false);
    setPartCost([]);
    baseApiCall({
      url: mis_reports_all_endpoints.GET_YEARLY_MONTHWISE_INCLUDING_IN_PART_COST_SUMMARY_DATA_BY_PLANT,
      requestBody: {
        start_date: monthlyDates?.start_date,
        end_date: monthlyDates?.end_date,
        plant_ids: selectedPlantName?.label === "All" ? selectedPlantName?.value : [selectedPlantName?.value],
      },
      method: commonVaribles.post,
      onSuccess: (res) => {
        if (res && res.data && res.data.result && res.data.result !== "") {
          const data = res.data.result;
          setPartCost(data);
          setLoader(true);
        } else {
          setPartCost(res.data.message);
          dispatch(
            onResponse({
              isToaster: true,
              severity: commonVaribles.success,
              message: res.data.message,
            })
          );
          setLoader(true);
        }
      },
      onFailure: () => {
        setLoader(false);
      },
      errorCall: () => {
        setLoader(false);
      },
    });
  };

  const Plantwise_Exp_Vs_strategy = () => {
    setLoader(false);
    setYearlyPlantWiseTable([]);
    baseApiCall({
      url: mis_reports_all_endpoints.GET_YEARLY_MONTHWISE_PLANWISE_VS_STRATEGY_SUMMARY_DATA_BY_PLANT,
      requestBody: {
        start_date: monthlyDates?.start_date,
        end_date: monthlyDates?.end_date,
        plant_ids: selectedPlantName?.label === "All" ? selectedPlantName?.value : [selectedPlantName?.value],
      },
      method: commonVaribles.post,
      onSuccess: (res) => {
        if (res && res.data && res.data.result && res.data.result !== "") {
          const data = res.data.result;
          setYearlyPlantWiseTable(data);
          setLoader(true);
        } else {
          setYearlyPlantWiseTable(res.data.message);
          dispatch(
            onResponse({
              isToaster: true,
              severity: commonVaribles.success,
              message: res.data.message,
            })
          );
          setLoader(true);
        }
      },
      onFailure: () => {
        setLoader(false);
      },
      errorCall: () => {
        setLoader(false);
      },
    });
  };

  const getSupplierWiseProgressData = () => {
    setLoader(false);
    setSupplierWiseProgressTable([]);
    baseApiCall({
      url: mis_reports_all_endpoints.GET_MONTHLY_SUPPLIER_WISE_PROGRESS_DATA_BY_PLANT,
      requestBody: {
        start_date: monthlyDates?.start_date,
        end_date: monthlyDates?.end_date,
        plant_ids: selectedPlantName?.label === "All" ? selectedPlantName?.value : [selectedPlantName?.value],
      },
      method: commonVaribles.post,
      onSuccess: (res) => {
        if (res?.data?.result?.length && res?.data?.result !== "") {
          const data = res.data.result;
          setSupplierWiseProgressTable(data);
          setLoader(true);
        } else {
          setSupplierWiseProgressTable(res.data.message);
          dispatch(
            onResponse({
              isToaster: true,
              severity: commonVaribles.success,
              message: res.data.message,
            })
          );
          setLoader(true);
        }
      },
      onFailure: () => {
        setLoader(false);
      },
      errorCall: () => {
        setLoader(false);
      },
    });
  };

  const Incoterm_data = () => {
    setLoader(false);
    setIncotermData([]);
    baseApiCall({
      url: mis_reports_all_endpoints.GET_YEARLY_MONTHWISE_INCOTERM_DATA_BY_PLANTS,
      requestBody: {
        start_date: monthlyDates?.start_date,
        end_date: monthlyDates?.end_date,
        plant_ids: selectedPlantName?.label === "All" ? selectedPlantName?.value : [selectedPlantName?.value],
      },
      method: commonVaribles.post,
      onSuccess: (res) => {
        if (res && res.data && res.data.result && res.data.result !== "") {
          const data = res.data.result;
          setIncotermData(data);
          setLoader(true);
        } else {
          setIncotermData(res.data.message);
          dispatch(
            onResponse({
              isToaster: true,
              severity: commonVaribles.success,
              message: res.data.message,
            })
          );
          setLoader(true);
        }
      },
      onFailure: () => {
        setLoader(false);
      },
      errorCall: () => {
        setLoader(false);
      },
    });
  };

  const ActiveUserList = () => {
    setLoader(false);
    baseApiCall({
      url: mis_reports_all_endpoints.GET_ACTIVE_USERS_LIST_BY_PLANT_IDS,
      requestBody: {
        start_date: monthlyDates?.start_date,
        end_date: monthlyDates?.end_date,
        plant_ids: selectedPlantName?.label === "All" ? selectedPlantName?.value : [selectedPlantName?.value],
      },
      method: commonVaribles.post,
      onSuccess: (res) => {
        if (res && res.data && res.data.result && res.data.result !== "") {
          const data = res.data.result;
          data.unshift({
            label: "All",
            value: "All",
          });
          setActiveUsers(data);
          setLoader(true);
        } else {
          setLoader(true);
        }
      },
      onFailure: () => {
        setLoader(true);
      },
      errorCall: () => {
        setLoader(true);
      },
    });
  };

  const handelActiveUsers = (event) => {
    setCurrentUser(event.target.value);
    if (JSON.parse(event?.target?.value)?.value === "All") {
      setIsAllUser(true);
    } else {
      setIsAllUser(false);
    }
  };

  const UserWise = () => {
    setLoader(false);
    setUserWiseInfo([]);
    baseApiCall({
      url: mis_reports_all_endpoints.GET_YEARLY_MONTHWISE_SUMMARY_DATA_BY_USERS,
      requestBody: {
        start_date: monthlyDates?.start_date,
        end_date: monthlyDates?.end_date,
        plant_ids: selectedPlantName?.label === "All" ? selectedPlantName?.value : [selectedPlantName?.value],
        is_all_user_names: isAllUser,
        user_names:
          currentUser?.length === 0
            ? [activeUsers[0]?.value]
            : [JSON.parse(currentUser)?.value],
      },
      method: commonVaribles.post,
      onSuccess: (res) => {
        if (res && res.data && res.data.result && res.data.result !== "") {
          const data = res.data.result;
          setUserWiseInfo(data[0].data);
          setLoader(true);
        } else {
          setUserWiseInfo(res.data.message);
          dispatch(
            onResponse({
              isToaster: true,
              severity: commonVaribles.success,
              message: res.data.message,
            })
          );
          setLoader(true);
        }
      },
      onFailure: () => {
        setLoader(false);
      },
      errorCall: () => {
        setLoader(false);
      },
    });
  };

  const fetchUserRoleList = () => {
		baseApiCall({
			url: user_management_service.GET_USER_ROLE_DETAILS,
			requestBody: {
				plant_ids: selectedPlantName?.label === "All" ? selectedPlantName?.value : [selectedPlantName?.value],
				Skipinterceptors: true,
			},
			method: commonVaribles.post,
			onSuccess: (res) => {
				if (res && res.data && res.data.result && res.data.result !== '') {
					const data = res.data.result;
          // Extract all 'value' fields from the result and create an array
          //const allRoleValues = data.map((item) => item.value);
          // data.unshift({
          //   label: "All",
          //   value: allRoleValues,
          // });
          setActiveRoles(data);
          setLoader(true);
        } else {
          setLoader(true);
        }
			},
			onFailure: () => {setLoader(true);},
			errorCall: () => {setLoader(true);},
		});
	};

  const handelActiveUserRoles = (event) => {
    setCurrentRole(event?.target?.value);
    if (JSON.parse(event?.target?.value)?.value === "All") {
      setIsAllRoles(true);
    } else {
      setIsAllRoles(false);
    }
  };

  const UserRoleWise = () => {
		setLoader(false);
		setUserRoleWiseInfo([]);
		baseApiCall({
			url: mis_reports_all_endpoints.GET_MONTHLY_USER_ROLE_WISE_PROGRESS_DATA_BY_PLANT,
			requestBody: {
				start_date: monthlyDates?.start_date,
				end_date: monthlyDates?.end_date,
				plant_ids:
					selectedPlantName?.label === 'All'
						? selectedPlantName?.value
						: [selectedPlantName?.value],
				is_all_user_roles: isAllURoles,
				user_role_ids:
					currentRole?.length === 0
						? [activeUserRoles[0]?.value]
						: [JSON.parse(currentRole)?.value],
			},
			method: commonVaribles.post,
			onSuccess: (res) => {
				if (res?.data?.result && res?.data?.result !== '') {
					const data = res.data.result;
					setUserRoleWiseInfo(data);
					setLoader(true);
				} else {
					setUserRoleWiseInfo(res.data.message);
					dispatch(
						onResponse({
							isToaster: true,
							severity: commonVaribles.success,
							message: res.data.message,
						})
					);
					setLoader(true);
				}
			},
			onFailure: () => {
				setLoader(false);
			},
			errorCall: () => {
				setLoader(false);
			},
		});
	};

  //Graphs
  const getPlantWiseogisticsSheetData = () => {
    setLoader(false);
    setPlantWiseSheet([]);
    baseApiCall({
      url: mis_reports_all_endpoints.GET_PLANT_WISE_LOGISTICS_RECOMMENDATIONS_SHEETS_DATA,
      requestBody: {
        start_date: monthlyDates?.start_date,
        end_date: monthlyDates?.end_date,
        plant_ids: selectedPlantName?.label === "All" ? selectedPlantName?.value : [selectedPlantName?.value],
      },
      method: commonVaribles.post,
      onSuccess: (res) => {
        if (res && res.data && res.data.result && res.data.result !== "") {
          const data = res.data.result;
          setPlantWiseSheet(data);
          setLoader(true);
        } else {
          dispatch(
            onResponse({
              isToaster: true,
              severity: commonVaribles.success,
              message: res.data.message,
            })
          );
          setLoader(true);
        }
      },
      onFailure: () => {
        setLoader(false);
      },
      errorCall: () => {
        setLoader(false);
      },
    });
  };

  const getPlantWiseLogisticsReturnablePercentageData = () => {
    setLoader(false);
    setPercentageData([]);
    baseApiCall({
      url: mis_reports_all_endpoints.GET_PLANT_WISE_LOGISTICS_RETURNABLE_PERCENTAGE_DATA,
      requestBody: {
        start_date: monthlyDates?.start_date,
        end_date: monthlyDates?.end_date,
        plant_ids: selectedPlantName?.label === "All" ? selectedPlantName?.value : [selectedPlantName?.value],
      },
      method: commonVaribles.post,
      onSuccess: (res) => {
        if (res && res.data && res.data.result && res.data.result !== "") {
          const data = res.data.result;
          setPercentageData(data);
          setLoader(true);
        } else {
          dispatch(
            onResponse({
              isToaster: true,
              severity: commonVaribles.success,
              message: res.data.message,
            })
          );
          setLoader(true);
        }
      },
      onFailure: () => {
        setLoader(false);
      },
      errorCall: () => {
        setLoader(false);
      },
    });
  };

  const getPlantWiseLogisticsReturnableExpendableCostData = () => {
    setLoader(false);
    setReturnableExpendableCostData([]);
    baseApiCall({
      url: mis_reports_all_endpoints.GET_PLANT_WISE_LOGISTICS_RETURNABLE_EXPENDABLE_COST_DATA,
      requestBody: {
        start_date: monthlyDates?.start_date,
        end_date: monthlyDates?.end_date,
        plant_ids: selectedPlantName?.label === "All" ? selectedPlantName?.value : [selectedPlantName?.value],
      },
      method: commonVaribles.post,
      onSuccess: (res) => {
        if (res && res.data && res.data.result && res.data.result !== "") {
          const data = res.data.result;
          setReturnableExpendableCostData(data);
          setLoader(true);
        } else {
          dispatch(
            onResponse({
              isToaster: true,
              severity: commonVaribles.success,
              message: res.data.message,
            })
          );
          setLoader(true);
        }
      },
      onFailure: () => {
        setLoader(false);
      },
      errorCall: () => {
        setLoader(false);
      },
    });
  };

  const getPlantWiseIcoTermWiseCostData = () => {
    setLoader(false);
    setIncoTermWiseCostData([]);
    baseApiCall({
      url: mis_reports_all_endpoints.GET_PLANT_WISE_INCO_TERM_COST_DATA,
      requestBody: {
        start_date: monthlyDates?.start_date,
        end_date: monthlyDates?.end_date,
        plant_ids: selectedPlantName?.label === "All" ? selectedPlantName?.value : [selectedPlantName?.value],
      },
      method: commonVaribles.post,
      onSuccess: (res) => {
        if (res && res.data && res.data.result && res.data.result !== "") {
          const data = res.data.result;
          setIncoTermWiseCostData(data);
          setLoader(true);
        } else {
          dispatch(
            onResponse({
              isToaster: true,
              severity: commonVaribles.success,
              message: res.data.message,
            })
          );
          setLoader(true);
        }
      },
      onFailure: () => {
        setLoader(false);
      },
      errorCall: () => {
        setLoader(false);
      },
    });
  };

  const getPlantWiseLogisticsCostData = () => {
    setLoader(false);
    setLogisticsCostData([]);
    baseApiCall({
      url: mis_reports_all_endpoints.GET_PLANT_WISE_LOGISTICS_COST_DATA,
      requestBody: {
        start_date: monthlyDates?.start_date,
        end_date: monthlyDates?.end_date,
        plant_ids: selectedPlantName?.label === "All" ? selectedPlantName?.value : [selectedPlantName?.value],
      },
      method: commonVaribles.post,
      onSuccess: (res) => {
        if (res && res.data && res.data.result && res.data.result !== "") {
          const data = res.data.result;
          setLogisticsCostData(data);
          setLoader(true);
        } else {
          dispatch(
            onResponse({
              isToaster: true,
              severity: commonVaribles.success,
              message: res.data.message,
            })
          );
          setLoader(true);
        }
      },
      onFailure: () => {
        setLoader(false);
      },
      errorCall: () => {
        setLoader(false);
      },
    });
  };

  const getPlantWiseogisticsAnnualCostData = () => {
    setLoader(false);
    setAnnualCostData([]);
    baseApiCall({
      url: mis_reports_all_endpoints.GET_PLANT_WISE_LOGISTICS_ANNUAL_COST_DATA,
      requestBody: {
        start_date: monthlyDates?.start_date,
        end_date: monthlyDates?.end_date,
        plant_ids: selectedPlantName?.label === "All" ? selectedPlantName?.value : [selectedPlantName?.value],
      },
      method: commonVaribles.post,
      onSuccess: (res) => {
        if (res && res.data && res.data.result && res.data.result !== "") {
          const data = res.data.result;
          setAnnualCostData(data);
          setLoader(true);
        } else {
          dispatch(
            onResponse({
              isToaster: true,
              severity: commonVaribles.success,
              message: res.data.message,
            })
          );
          setLoader(true);
        }
      },
      onFailure: () => {
        setLoader(false);
      },
      errorCall: () => {
        setLoader(false);
      },
    });
  };

  const getPlantWiseogisticsAnnualRecommendationsData = () => {
    setLoader(false);
    setAnnualRecommendationsData([]);
    baseApiCall({
      url: mis_reports_all_endpoints.GET_PLANT_WISE_LOGISTICS_ANNUAL_RECOMMENDATIONS_DATA,
      requestBody: {
        start_date: monthlyDates?.start_date,
        end_date: monthlyDates?.end_date,
        plant_ids: selectedPlantName?.label === "All" ? selectedPlantName?.value : [selectedPlantName?.value],
      },
      method: commonVaribles.post,
      onSuccess: (res) => {
        if (res && res.data && res.data.result && res.data.result !== "") {
          const data = res.data.result;
          setAnnualRecommendationsData(data);
          setLoader(true);
        } else {
          dispatch(
            onResponse({
              isToaster: true,
              severity: commonVaribles.success,
              message: res.data.message,
            })
          );
          setLoader(true);
        }
      },
      onFailure: () => {
        setLoader(false);
      },
      errorCall: () => {
        setLoader(false);
      },
    });
  };

  const getPlantWiseogisticsAnnualRecommendationsCountAndCostData = () => {
    setLoader(false);
    setCountAndCostData([]);
    baseApiCall({
      url: mis_reports_all_endpoints.GET_PLANT_WISE_LOGISTICS_RECOMMENDATIONS_COUNT_AND_COST_DATA,
      requestBody: {
        start_date: monthlyDates?.start_date,
        end_date: monthlyDates?.end_date,
        plant_ids: selectedPlantName?.label === "All" ? selectedPlantName?.value : [selectedPlantName?.value],
      },
      method: commonVaribles.post,
      onSuccess: (res) => {
        if (res && res.data && res.data.result && res.data.result !== "") {
          const data = res.data.result;
          setCountAndCostData(data);
          setLoader(true);
        } else {
          dispatch(
            onResponse({
              isToaster: true,
              severity: commonVaribles.success,
              message: res.data.message,
            })
          );
          setLoader(true);
        }
      },
      onFailure: () => {
        setLoader(false);
      },
      errorCall: () => {
        setLoader(false);
      },
    });
  };

  const ExcelConverter = (data, name) => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, `${name}.xlsx`);
  };

  const downloadMisReport = () => {
    baseApiCall({
      url: mis_reports_all_endpoints.GET_MONTHLY_STRATEGY_DETAILS_LIST,
      requestBody: {
        start_date: monthlyDates?.start_date,
        end_date: monthlyDates?.end_date,
        plant_ids: selectedPlantName?.label === "All" ? selectedPlantName?.value : [selectedPlantName?.value],
      },
      method: commonVaribles.post,
      onSuccess: (res) => {
        if (res && res.data && res.data.result && res.data.result !== "") {
          const data = res.data.result;
          const actualData = [];
          data.map((value, index) => {
            const final = {
							'Sr No.': index + 1,
							'Part No.': value?.Strategies_table?.part_info_data?.part_no,
							'Part Description':
								value?.Strategies_table?.part_info_data?.part_description,
							'Part Weight(Kg)':
								value?.Strategies_table?.part_info_data?.part_weight,
							'Part Dimension(mm)':
								value?.Strategies_table?.part_info_data?.part_dimension,
							'Receiving Location(TML Plant)':
								value?.Strategies_table?.part_info_data?.receiving_location,
							'Part Per Vehicle':
								value?.Strategies_table?.part_info_data?.part_per_vehicle,
							'Vendor Code':
								value?.Strategies_table?.supply_info_data?.vendor_code,
							'Vendor Name':
								value?.Strategies_table?.supply_info_data?.company_name,
							'Vendor Address':
								value?.Strategies_table?.supply_info_data?.company_address,
							'Contact Person':
								value?.Strategies_table?.supply_info_data?.contact_person,
							'Email': value?.Strategies_table?.supply_info_data?.email,
							'State': value?.Strategies_table?.supply_info_data?.state,
							'Tel No': value?.Strategies_table?.supply_info_data?.tel_no,
							'Fax No': value?.Strategies_table?.supply_info_data?.fax_no,

							'Inco Terms': value?.Strategies_table?.shipping_info?.inco_terms,
							'Tonnage of Inco Terms':
								value?.Strategies_table?.part_info_data?.tonnage,
							'Primary Strategy(Returnable Expendable)':
								value?.Strategies_table?.primary_packaging_info
									?.primary_packaging_strategy,
							'Secondary Strategy(Returnable Expendable)':
								value?.Strategies_table?.secondary_packaging_info
									?.secondary_packaging_strategy,
							'Primary Carton Code':
								value?.Strategies_table?.primary_packaging_info
									?.primary_carton_code,
							'Secondary Carton Code':
								value?.Strategies_table?.secondary_packaging_info
									?.secondary_carton_code,
							'Primary Carton Type':
								value?.Strategies_table?.secondary_packaging_info
									?.primary_carton_type,
							'Secondary Carton Type':
								value?.Strategies_table?.secondary_packaging_info
									?.secondary_carton_type,
							'Primary Packaging Material':
								value?.Strategies_table?.primary_packaging_info
									?.primary_packaging_material,
							'Secondary Packaging Material':
								value?.Strategies_table?.secondary_packaging_info
									?.secondary_packaging_material,
							'Primary Securement':
								value?.Strategies_table?.primary_packaging_info
									?.primary_securement,
							'Secondary Securement':
								value?.Strategies_table?.secondary_packaging_info
									?.secondary_securement,
							'Primary Total Loaded':
								value?.Strategies_table?.primary_packaging_info
									?.primary_total_loaded,
							'Secondary Total Loaded':
								value?.Strategies_table?.secondary_packaging_info
									?.secondary_total_loaded,
							'Primary Outside Dimension':
								value?.Strategies_table?.primary_packaging_info
									?.primary_outside_dimension
                  ? replacingCommaToX(value?.Strategies_table?.primary_packaging_info?.primary_outside_dimension) : '-',
							'Secondary Outside Dimension':
								value?.Strategies_table?.secondary_packaging_info
									?.secondary_outside_dimension ?
                  replacingCommaToX(value?.Strategies_table?.secondary_packaging_info?.secondary_outside_dimension) : '-',
							'Primary Density(Nos)':
								value?.Strategies_table?.primary_packaging_info
									?.primary_density,
							'Secondary Density(Nos)':
								value?.Strategies_table?.secondary_packaging_info
									?.secondary_density,
							'Primary Dunnage Description':
								value?.Strategies_table?.primary_packaging_info
									?.primary_dunnage_description,
							'Secondary Dunnage Description':
								value?.Strategies_table?.secondary_packaging_info
									?.secondary_dunnage_description,
							'Primary Labels':
								value?.Strategies_table?.primary_packaging_info?.primary_labels,
							'Secondary Labels':
								value?.Strategies_table?.secondary_packaging_info
									?.secondary_labels,
							'Primary Container Ownership':
								value?.Strategies_table?.primary_packaging_info
									?.primary_container_ownership,
							'Secondary Container Ownership':
								value?.Strategies_table?.secondary_packaging_info
									?.secondary_container_ownership,

							'Transportation Mode':
								value?.Strategies_table?.shipping_info?.transportation_mode,
							'Pallet Dimensions':
								value?.Strategies_table?.shipping_info?.pallet_dimensions,
							'Sec Packaging Per Transit Modes':
								value?.Strategies_table?.shipping_info
									?.sec_packaging_per_transit_modes,
							'No of Pry Packs Per Sec Packs':
								value?.Strategies_table?.shipping_info
									?.no_of_pry_packs_per_sec_packs,
							'Hazardous Material Class':
								value?.Strategies_table?.shipping_info
									?.hazardous_material_class,
							'Loop Size': value?.Strategies_table?.shipping_info?.loop_size,
							'Life Returnable Packaging':
								value?.Strategies_table?.shipping_info
									?.life_returnable_packaging,
							'Unloading Loading Responsibility':
								value?.Strategies_table?.shipping_info
									?.unloading_loading_responsibility,
							'Supply Tml': value?.Strategies_table?.shipping_info?.supply_tml,
							'Theoretical Cubic Utilisation':
								value?.Strategies_table?.shipping_info
									?.theoretical_cubic_utilisation,
							'Remarks': value?.Strategies_table?.shipping_info?.remarks,

							'Included in Part Cost': value?.Strategies_table?.part_info_data
								?.included_in_part_cost
								? value?.Strategies_table?.part_info_data?.included_in_part_cost
								: '-',
							'Recommended By':
								value?.Strategies_table?.part_info_data?.recommended_by,
							'Packaging Person':
								value?.Strategies_table?.approval_info?.packaging_person,
							'Packaging Person Date': value?.Strategies_table?.approval_info
								?.packaging_person_date
								? formatDate(
										value?.Strategies_table?.part_info_data
											?.packaging_person_date
									)
								: '-',
							'Purchasing Buyer':
								value?.Strategies_table?.approval_info?.purchasing_buyer,
							'Purchasing Buyer Date': value?.Strategies_table?.approval_info
								?.purchasing_buyer_date
								? formatDate(
										value?.Strategies_table?.part_info_data
											?.purchasing_buyer_date
									)
								: '-',
							'SCM Buyer': value?.Strategies_table?.approval_info?.scm,
							'SCM Buyer Date': value?.Strategies_table?.approval_info?.scm_date
								? formatDate(value?.Strategies_table?.part_info_data?.scm_date)
								: '-',
							'Miscellaneous Comment':
								value?.Strategies_table?.approval_info?.miscellaneous_comment,

							'Model Applicable(Project)':
								value?.Strategies_table?.part_info_data?.models_applicable,
							'Approval Type':
								value?.Strategies_table?.approval_info?.approval_type,
							'Approval Status':
								value?.Strategies_table?.approval_info?.approval_status,

							'Date of Logistics Sheet Recommended': value?.Strategies_table
								?.approval_info?.approval_date
								? formatDate(
										value?.Strategies_table?.approval_info?.approval_date
									)
								: '-',
							'Date of Logistics Sheet Requested': value?.Strategies_table
								?.approval_info?.date_of_logistics_sheet_requested
								? formatDate(
										value?.Strategies_table?.approval_info
											?.date_of_logistics_sheet_requested
									)
								: '-',
              'Tml Settled Transportation Cost':
                value?.Strategies_table?.part_info_data?.tml_settled_transportation_cost,
              'Tml Settled Packaging Cost':
                value?.Strategies_table?.part_info_data?.tml_settled_packaging_cost,
							'TML Packaging Cost / Part':
								value?.Strategies_table?.part_info_data
									?.packaging_cost_per_part,
							'Supplier Packaging Cost / Part':
								value?.Strategies_table?.part_info_data
									?.supplier_packaging_cost,
							'TML Transportation Cost / Part':
								value?.Strategies_table?.part_info_data
									?.transportation_cost_per_part,
							'Supplier Transportation Cost / Part':
								value?.Strategies_table?.part_info_data
									?.supplier_transport_cost,
							'Annual Volume (Nos)':
								value?.Strategies_table?.part_info_data?.annual_volume,
							'Tml (P+T) cost ₹':
								value?.Strategies_table?.part_info_data
									?.tml_packaging_transport_cost,
							'Supp(P+T) cost ₹':
								value?.Strategies_table?.part_info_data
									?.supplier_packaging_transport_cost,
							'Cost Avoidance ₹':
								value?.Strategies_table?.part_info_data?.cost_avoidance,
						};
            actualData.push(final);
          });
          ExcelConverter(
            actualData,
            `MIS-Summary_${monthlyDates?.start_date}-${monthlyDates?.end_date}`
          );
        } else {
          dispatch(
            onResponse({
              isToaster: true,
              severity: commonVaribles.error,
              message: commonVaribles.data_not_found
            })
          );
          // setLoader(true);
        }
      },
      onFailure: () => {
        setLoader(false);
      },
      errorCall: () => {
        setLoader(false);
      },
    });
  };

  const handleAssigneeValue = async (value, name) => {
		// Update selected plant with the correct value
		setSelectedOption((prev) => ({
			...prev,
			[name]: value, // Set to 'All' or the selected plant ID
		}));

		// Handle specific logic for selected plant name
		setSelectedPlantName(value); // This will be the ID of the selected plant
	};

  return (
    <div>
      <div className={globalstyle.breadcrumb}>
        <BackButton
          basePath={Title.home}
          action={Title.mis_reports}
          handleClick={() => {
            navigate("/");
          }}
          browserBack={true}
        />
      </div>
      {loader ? (
        <>
          <div className={styles["customTabMisPage"]}>
            <CustomTab
              title={Title.mis_reports}
              count={0}
              withOutCount={true}
              searchQuery={null}
              isSearchBar={false}
              setSearchQuery={() => { }}
              isDatepicker={false}
              isDropdown={false}
              isSelected={false}
              isCheckbox={false}
              onChangeDatefilter={() => { }}
              searchValueFetch={() => { }}
              dateClearFilter={() => { }}
            />
          </div>
          <div className={styles.thirdHeaderComponents}>
            <div className={styles.thirdHeaderComponentsTabs}>
              {tabs.map((tabName) => (
                <div
                  key={tabName}
                  className={
                    currentTab === tabName
                      ? styles.thirdHeaderComponentsTabCurrent
                      : styles.thirdHeaderComponentsTab
                  }
                  onClick={() => handleTabClick(tabName)}
                >
                  {tabName}
                </div>
              ))}
            </div>
            <div className={styles.thirdHeaderComponentsButtons}>
              <div>
                {downloadMisReportSummury.includes(currentTab) && (
                  <Button
                    children={commonVaribles.download_summary}
                    variant={constants.BUTTON_ATOMIC_COMPONENT.FEEDBACKS}
                    onClick={() => downloadMisReport()}
                  />
                )}
              </div>
              {currentTab === 'Plantwise' && (
                <div className={styles.plantDropdown}>
                  <Select
                    value={selectedPlantName}
                    styles={customStyle}
                    options={modifiedPlantDataList}
                    onChange={(e) => handleAssigneeValue(e, 'selected_plant')}
                  />
                </div>
              )}
              <div>
                {currentTab === "Monthly" ? (
                  <MonthYearFilter
                    isMonthly={true}
                    setMonthlyDates={setMonthlyDates}
                    selectedMonthYear={selectedMonthYear}
                    setSelectedMonthYear={setSelectedMonthYear}
                  />
                ) : (
                  <MonthYearFilter
                    isYearly={true}
                    setMonthlyDates={setMonthlyDates}
                    setSelectedYear={setSelectedYear}
                    selectedYear={selectedYear}
                  />
                )}
              </div>
            </div>
          </div>
          <div className={styles.misContainerPage}>
            {tabContent[currentTab] && (
              <>
                {tabContent[currentTab].cards && (
                  <div className={styles.misContainerPageCards}>
                    {tabContent[currentTab].cards.map((card, index) => (
                      <MisContainerPageCard key={index} {...card} />
                    ))}
                  </div>
                )}

                {tabContent[currentTab].table3 && (
									<div className={styles.misReportsTableComponent}>
										<div className={styles.headers}>
											<div> {tabContent[currentTab].table3.headerName}</div>
											{tabContent[currentTab]?.table3?.isUserDropDown && (
												<div className={styles.selectWrapper}>
													<select
														className={clsx(styles.monthYearFilterSelect, styles.roleWiseFilterSelect)}
														defaultValue={activeUserRoles[0]?.label}
														value={currentRole}
														onChange={handelActiveUserRoles}
													>
														{activeUserRoles.map((option, index) => (
															<option
																className={styles.monthYearFilterSelectOptions}
																key={index}
																value={JSON.stringify(option)}
															>
																{option.label}
															</option>
														))}
													</select>
													{/* <ArrowDropDownIcon className={styles.customIcon} /> */}
												</div>
											)}
										</div>
										{typeof userRoleWiseInfo !== 'string' ? (
											<YearlyTable plants={userRoleWiseInfo} headerName={'Name/ Plant'} />
										) : (
											<div className={styles.containers}>
												{commonVaribles.data_not_found}
											</div>
										)}
									</div>
								)}

                {tabContent[currentTab].plantVsCostTable && (
                  <div className={styles.misReportsTableComponent}>
                    <>
                      <div className={styles.headers}>
                        <div>
                          {" "}
                          {
                            tabContent[currentTab]?.plantVsCostTable?.headerName
                          }{" "}
                        </div>
                      </div>
                      {typeof partCost !== "string" ? (
                        <div className={styles.yearlyTable}>
                          <PlantVsCostTable data={partCost} />
                        </div>
                      ) : (
                        <div className={styles.containers}>
                          {" "}
                          {commonVaribles.data_not_found}
                        </div>
                      )}
                    </>
                  </div>
                )}

                {tabContent[currentTab].table1 && (
                  <div className={styles.misReportsTableComponent}>
                    <div className={styles.headers}>
                      <div> {tabContent[currentTab].table1.headerName} </div>
                      {activeUsers.length > 0 &&
                        tabContent[currentTab]?.table1?.isUserDropDown && (
                          <div className={styles.selectWrapper}>
                            <select
                              className={styles.monthYearFilterSelect}
                              defaultValue={activeUsers[0].lebel}
                              value={currentUser}
                              onChange={handelActiveUsers}
                            >
                              {activeUsers.map((option, index) => (
                                <option
                                  className={
                                    styles.monthYearFilterSelectOptions
                                  }
                                  key={index}
                                  value={JSON.stringify(option)}
                                >
                                  {option.label}
                                </option>
                              ))}
                            </select>
                            {/* <ArrowDropDownIcon className={styles.customIcon} /> */}
                          </div>
                        )}
                    </div>
                    {typeof userWiseInfo !== "string" ? (
                      <MisTableComponent {...tabContent[currentTab].table1} />
                    ) : (
                      <div className={styles.containers}>
                        {commonVaribles.data_not_found}
                      </div>
                    )}
                  </div>
                )}

                {tabContent[currentTab].yearlysTable1 && (
                  <div className={styles.misReportsTableComponent}>
                    <>
                      <div className={styles.headers}>
                        <div>
                          {tabContent[currentTab]?.yearlysTable1?.headerName}
                        </div>
                      </div>
                      {typeof yearlyPlantWiseTable !== "string" ? (
                        <div className={styles.yearlyTable}>
                          <YearlyTable plants={yearlyPlantWiseTable} />
                        </div>
                      ) : (
                        <div className={styles.containers}>
                          {commonVaribles.data_not_found}
                        </div>
                      )}
                    </>
                  </div>
                )}

                {tabContent[currentTab].yearlysTable2 && (
                  <div className={styles.misReportsTableComponent}>
                    <div className={styles.headers}>
                      <div>
                        {tabContent[currentTab]?.yearlysTable2?.headerName}
                      </div>
                    </div>
                    {typeof incotermData !== "string" ? (
                      <div className={styles.yearlyTable}>
                        <YearlyTable plants={incotermData} />
                      </div>
                    ) : (
                      <div className={styles.containers}>
                        {commonVaribles.data_not_found}
                      </div>
                    )}
                  </div>
                )}

                {tabContent[currentTab].table2 && (
                  <div className={styles.misReportsTableComponent}>
                    <div className={styles.headers}>
                      <div> {tabContent[currentTab].table2.headerName}</div>
                    </div>
                    {typeof userWiesData !== "string" ? (
                      <MisTableComponent {...tabContent[currentTab].table2} />
                    ) : (
                      <div className={styles.containers}>
                        {commonVaribles.data_not_found}
                      </div>
                    )}
                  </div>
                )}

                {tabContent[currentTab].table4 && (
                  <div className={styles.misReportsTableComponent}>
                    <div className={styles.headers}>
                      <div> {tabContent[currentTab].table4.headerName}</div>
                    </div>
                    {typeof modelWiseConstingTable !== 'string' ? (
                      <YearlyTable plants={modelWiseConstingTable} headerName={'Model/ Plant'}/>
                    ) : (
                      <div className={styles.containers}>
                        {commonVaribles.data_not_found}
                      </div>
                    )}
                  </div>
                )}

                {tabContent[currentTab].graph &&
                  (tabContent[currentTab].graph ? (
                    <div className={styles.misReportsTableComponent}>
                      <MisReportGraph
                        plantWiseSheet={plantWiseSheet}
                        percentageData={percentageData}
                        logisticsCostData={logisticsCostData}
                        annualCostData={annualCostData}
                        annualRecommendationsData={annualRecommendationsData}
                        countAndCostData={countAndCostData}
                        returnableExpendableCostData={returnableExpendableCostData}
                        IncoTermWiseCostData={IncoTermWiseCostData}
                      />
                    </div>
                  ) : (
                    <Loader />
                  ))}

                {/* {typeof otherData !== "string" ? (
                  tabContent[currentTab].misCardSection &&
                  otherData &&
                  (otherData.length !== 0 ? (
                    <div className={styles.misReportsTableComponent}>
                      <div className={styles.headers}>
                        <span> Other Data </span>
                      </div>
                      <div className={styles.misCardSections}>
                        <div className={styles.misCardSectionLeft}>
                          <div className={styles.misCardSection}>
                            <div className={styles.misCardSectionsTitle}>
                              1 <span>FCA Approval (Part load Basis)</span>
                            </div>
                            <div>{otherData?.fca_part_load}</div>
                          </div>
                          <div className={styles.misCardSection}>
                            <div className={styles.misCardSectionsTitle}>
                              2 <span>Approval of EV Vehicles Parts (Nos.)</span>
                            </div>
                            <div> {otherData?.no_of_ev_vehicles}</div>
                          </div>
                        </div>
                        <div className={styles.misCardSectionRight}>
                          <div className={styles.misCardSection}>
                            <div className={styles.misCardSectionsTitle}>
                              3 <span>Approval of CNG Vehicles Parts (Nos.)</span>
                            </div>
                            <div> {otherData?.no_of_cng_vehicles}</div>
                          </div>
                          <div className={styles.misCardSection}>
                            <div className={styles.misCardSectionsTitle}>
                              4 <span>Avg. No. of Days / Recommendation</span>
                            </div>
                            <div>
                              {otherData?.avg_no_of_days_per_recommendation}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <Loader />
                  ))
                ) : (
                  <div className={styles.containers}>
                    {commonVaribles.data_not_found}
                  </div>
                )} */}
              </>
            )}
          </div>
        </>
      ) : (
        <div className={styles.loaderDiv}>
          <Loader />
        </div>
      )}
    </div>
  );
}
